import { MemberDto, MemberMetaDto } from '@careapp-group/ng-sdk-v2-new';
import { Action, createAction, props } from '@ngrx/store';
import {
  RecoveryFlow,
  RegistrationFlow,
  Session,
  SuccessfulNativeRegistration,
  UpdateRegistrationFlowBody,
  VerificationFlow,
} from '@ory/client';

export const REQUEST_AUTH_LOGIN = '[Auth][Request] Auth Login';
export const RESPONSE_SUCCESS_AUTH_LOGIN = '[Auth][Response][Success] Auth Login';
export const RESPONSE_FAIL_AUTH_LOGIN = '[Auth][Response][Fail] Auth Login';

const REQUEST_AUTH_LOGOUT = '[Auth][Request] Auth Logout';
const RESPONSE_SUCCESS_AUTH_LOGOUT = '[Auth][Response][Success] Auth Logout';
export const RESPONSE_FAIL_AUTH_LOGOUT = '[Auth][Response][Fail] Auth Logout';

export const REQUEST_AUTH_REFRESH = '[Auth][Request] Auth Refresh';
export const RESPONSE_SUCCESS_AUTH_REFRESH = '[Auth][Response][Success] Auth Refresh';
export const RESPONSE_FAIL_AUTH_REFRESH = '[Auth][Response][Fail] Auth Refresh';

export const REQUEST_UPDATE_MEMBER_META = '[Auth][Request] Update Member Meta';
export const RESPONSE_SUCCESS_UPDATE_MEMBER_META = '[Auth][Response][Success] Update Member Meta';
export const RESPONSE_FAIL_UPDATE_MEMBER_META = '[Auth][Response][Fail] Update Member Meta';

const REQUEST_CHANGE_PASSWORD = '[Profile][Request] Password change';
const RESPONSE_SUCCESS_CHANGE_PASSWORD = '[Profile][Response][Success] Password change';
const RESPONSE_FAIL_CHANGE_PASSWORD = '[Profile][Response][Fail] Password change';

export const REQUEST_AUTH_FORGOT_PASSWORD = '[Auth][Request] Auth Forgot Password';
export const RESPONSE_SUCCESS_AUTH_FORGOT_PASSWORD =
  '[Auth][Response][Success] Auth Forgot Password';
export const RESPONSE_FAIL_AUTH_FORGOT_PASSWORD = '[Auth][Response][Fail] Auth Forgot Password';
export const REQUEST_LOGGED_IN_USER = '[Auth][Request] get logged in user';
export const RESPONSE_SUCCESS_LOGGED_IN_USER = '[Auth][Response][Success] get logged in user';
export const RESPONSE_FAIL_LOGGED_IN_USER = '[Auth][Response][Fail] get logged in user';

export const REQUEST_USER_ROLES = '[Auth][Request] User Roles';
export const RESPONSE_SUCCESS_USER_ROLES = '[Auth][Response][Success] User Roles';
export const RESPONSE_FAIL_USER_ROLES = '[Auth][Response][Fail] User Roles';

export const AUTH_RESET_ERRORS = '[Auth] Auth Reset Errors';
export const FORCE_LOGOUT_401 = '[Auth] Force Logout 401';
export const HYDRATE_AUTH = '[Auth] Hydrate Auth';

export class RequestLoggedInUser implements Action {
  readonly type = REQUEST_LOGGED_IN_USER;
  constructor(public payload: string) {}
}

export class ResponseSuccessLoggedInUser implements Action {
  readonly type = RESPONSE_SUCCESS_LOGGED_IN_USER;
  constructor(public payload: MemberDto) {}
}

export class ResponseFailLoggedInUser implements Action {
  readonly type = RESPONSE_FAIL_LOGGED_IN_USER;
  constructor(public payload: any) {}
}

export class RequestUserRoles implements Action {
  readonly type = REQUEST_USER_ROLES;
  constructor() {}
}

export class ResponseSuccessUserRoles implements Action {
  readonly type = RESPONSE_SUCCESS_USER_ROLES;
  constructor(public payload: string[]) {}
}

export class ResponseFailUserRoles implements Action {
  readonly type = RESPONSE_FAIL_USER_ROLES;
  constructor(public payload: any) {}
}

export const RequestLoginAction = createAction(
  REQUEST_AUTH_LOGIN,
  props<{ email?: string; phoneNumber?: string; password: string }>()
);

export const RequestAuthLogoutAction = createAction(
  REQUEST_AUTH_LOGOUT,
  props<{ stayOnCurrentRoute?: boolean }>()
);
export const ResponseSuccessAuthLogoutAction = createAction(
  RESPONSE_SUCCESS_AUTH_LOGOUT,
  props<{ stayOnCurrentRoute?: boolean }>()
);

export const ResponseSuccessAuthLoginAction = createAction(
  RESPONSE_SUCCESS_AUTH_LOGIN,
  props<{ session?: Session; userId?: string; payload?: any }>()
);

export class ResponseFailAuthLoginAction implements Action {
  readonly type = RESPONSE_FAIL_AUTH_LOGIN;
  constructor(public payload: any) {}
}
export class ResponseFailAuthLogoutAction implements Action {
  readonly type = RESPONSE_FAIL_AUTH_LOGOUT;
  constructor(public payload: any) {}
}

export class RequestAuthForgotPasswordAction implements Action {
  readonly type = REQUEST_AUTH_FORGOT_PASSWORD;
  constructor(public payload: { email: string }) {}
}

export class ResponseSuccessAuthForgotPasswordAction implements Action {
  readonly type = RESPONSE_SUCCESS_AUTH_FORGOT_PASSWORD;
}

export class ResponseFailAuthForgotPasswordAction implements Action {
  readonly type = RESPONSE_FAIL_AUTH_FORGOT_PASSWORD;
  constructor(public payload: any) {}
}

export class AuthResetErrorsAction implements Action {
  readonly type = AUTH_RESET_ERRORS;
}

export class RequestAuthRefreshAction implements Action {
  readonly type = REQUEST_AUTH_REFRESH;
}

export const ResponseSuccessSessionRefreshAction = createAction(
  RESPONSE_SUCCESS_AUTH_REFRESH,
  props<{ payload?: any }>()
);

export class ResponseFailAuthRefreshAction implements Action {
  readonly type = RESPONSE_FAIL_AUTH_REFRESH;
  constructor(public payload?: any) {}
}

export const RequestUpdateMemberMetaAction = createAction(
  REQUEST_UPDATE_MEMBER_META,
  props<{ payload: Partial<MemberMetaDto> }>()
);

export const ResponseSuccessUpdateMemberMetaAction = createAction(
  RESPONSE_SUCCESS_UPDATE_MEMBER_META,
  props<{ payload: MemberMetaDto }>()
);

export const ResponseFailUpdateMemberMetaAction = createAction(
  RESPONSE_FAIL_UPDATE_MEMBER_META,
  props<{ payload: any }>()
);

export class ForceLogout401 implements Action {
  readonly type = FORCE_LOGOUT_401;
  constructor(public payload?: string) {}
}

export class HydrateAuth implements Action {
  readonly type = HYDRATE_AUTH;
  constructor(public payload?: { id: string; userId: string }) {}
}

export const BeginPasswordChange = createAction('BEGIN_PASSWORD_CHANGE');

export const RequestChangePasswordAction = createAction(
  REQUEST_CHANGE_PASSWORD,
  props<{ password: string }>()
);

export const ResponseSuccessChangePasswordAction = createAction(
  RESPONSE_SUCCESS_CHANGE_PASSWORD,
  props<any>()
);

export const ResponseFailChangePasswordAction = createAction(
  RESPONSE_FAIL_CHANGE_PASSWORD,
  props<{ error: any }>()
);

export const ClearRecoveryFlow = createAction('[Auth] Clear recovery flow');

export const RequestBeginAccountRecovery = createAction(
  '[Auth][Request] Begin account recovery',
  props<{ email: string }>()
);
export const SuccessBeginAccountRecovery = createAction(
  '[Auth][Response][Success] Begin account recovery',
  props<{ flow: RecoveryFlow }>()
);
export const FailBeginAccountRecovery = createAction(
  '[Auth][Response][Fail] Begin account recovery',
  props<{ error: any }>()
);

export const RequestCompleteAccountRecovery = createAction(
  '[Auth][Request] Complete account recovery',
  props<{ code: string }>()
);

export const SuccessCompleteAccountRecovery = createAction(
  '[Auth][Response][Success] Complete account recovery',
  props<{ res: any; passwordChangeFlowId: string }>()
);

export const FailCompleteAccountRecovery = createAction(
  '[Auth][Response][Fail] Complete account recovery',
  props<{ error: any }>()
);

export const RequireLogin = createAction(
  '[Auth] Request Login',
  props<{ postLoginRoute?: string }>()
);
export const AtLogin = createAction('[Auth] At Login');

export const RequireRegistration = createAction(
  '[Auth] Request Registration',
  props<{ postLoginRoute?: string; query?: any }>()
);
export const AtRegistration = createAction('[Auth] At Registration');

export const RequestBeginRegistrationFlow = createAction(
  '[Auth][Registration][Request] begin flow'
);
export const SuccessBeginRegistrationFlow = createAction(
  '[Auth][Registration][Success] begin flow',
  props<{ flow: RegistrationFlow }>()
);
export const FailBeginRegistrationFlow = createAction(
  '[Auth][Registration][Fail] begin flow',
  props<{ error: any }>()
);

export const RequestCompleteRegistrationFlow = createAction(
  '[Auth][Registration][Request] complete flow',
  props<{ payload: UpdateRegistrationFlowBody }>()
);
export const SuccessCompleteRegistrationFlow = createAction(
  '[Auth][Registration][Success] complete flow',
  props<{ response: SuccessfulNativeRegistration }>()
);

/**
 * Registration errors return a new flow to show to the user
 */
export const FailCompleteRegistrationFlow = createAction(
  '[Auth][Registration][Fail] complete flow',
  props<{ response: RegistrationFlow }>()
);

export const RequestUpdateVerificationFlow = createAction(
  '[Auth][Verification][Request] update flow',
  props<{ code?: string; email?: string }>()
);
export const SuccessUpdateVerificationFlow = createAction(
  '[Auth][Verification][Success] update flow',
  props<{ response: VerificationFlow }>()
);
export const FailUpdateVerificationFlow = createAction(
  '[Auth][Verification][Fail] update flow',
  props<{ response: VerificationFlow }>()
);

export const RequestGetVerificationFlow = createAction(
  '[Auth][Verification][Request] get flow',
  props<{ id: string }>()
);
export const RequestCreateVerificationFlow = createAction(
  '[Auth][Verification][Request] create flow'
);

export const SuccessGetVerificationFlow = createAction(
  '[Auth][Verification][Success] get flow',
  props<{ flow: VerificationFlow }>()
);
export const FailGetVerificationFlow = createAction(
  '[Auth][Verification][Fail] get flow',
  props<{ error: any }>()
);
